/*
  The message thread list that appears when clicking a MessageThreadHeader in ActionsPanel
  the job of this component is to map over the passed state.msgThread object
  from the parent.
*/

import React from 'react';
import { object, string } from 'prop-types';
import moment from 'moment';
import { last, reverse } from 'ramda';

import MessageThreadListItem from '../MessageThreadListItem';
import Attachments from "../Attachments";

import s from './MessageThreadList.css';


const MessageThreadList = ({ ...props }) => {

  const thread = props.thread;
  const subject = props.subject;
  const lastThreadItem = last(thread.items);
  const attachments = thread.attachments;
  const messages = reverse(thread.items);
  let threadContents;

  if (messages) {
    threadContents = messages.map((message) => {

      const msgId = message.id;
      const content = message.content;
      const from = message.from;
      const formElements = message.formElements;

      const convertTime = (date) => moment.unix(date / 1000).format('h:mm A, MMM Do, YYYY');
      const convertedTimestamp = convertTime(message.timestamp);

      return (
        <MessageThreadListItem
          key={msgId}
          id={msgId}
          from={from}
          content={content}
          formElements={formElements}
          timestamp={convertedTimestamp}
          lastThreadItem={lastThreadItem}
        />
      );

    });
  }

  return (
    <section className={s.component}>
      <header className={s.header}>
        {subject}
      </header>
      {threadContents}
      <Attachments attachments={attachments} />
    </section>
  );
};

MessageThreadList.propTypes = {
  thread: object,
  subject: string,
};

export default MessageThreadList;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadList/MessageThreadList.js